module.exports = __webpack_public_path__ + "img/04.bb3758b0.jpg";